import { database } from '../config';
import ErrorLog from './error';
const Error = new ErrorLog()

export default class Contacto {
    constructor() {
        this.Nombre = ''
        this.Correo = ''
        this.Telefono = ''
        this.Mensaje = ''
        this.Fecha = new Date()
    }

    enviarCorreo(contacto) {
        return database.collection('correos').add({
            ...contacto,
        })
            .then()
            .catch(error => console.error(Error.guardarError(error)))
    }

}